import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { UserKeys } from '../../../api/users-api';
import {
  DriveRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';
import { Messages } from '../../../utils/message-constants';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';
interface SharedDrivesIndexedGridToolbarProps {
  driveRoles: string[];
  setOpenCreateSharedDriveDialog: Dispatch<SetStateAction<boolean>>;
  requiresChangeLog?: boolean;
  changeLogConfirmed?: boolean;
}

export default function SharedDrivesIndexedGridToolbar({
  driveRoles,
  setOpenCreateSharedDriveDialog,
  requiresChangeLog = false,
  changeLogConfirmed = false,
}: SharedDrivesIndexedGridToolbarProps) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      quickFilterPlaceholder="Search By Name..."
      quickFilterDebounceMs={500}
      primaryButtons={
        <CreateButton
          disabled={
            !isAbleToSeeUIElement(
              driveRoles,
              DriveRoles.CanCreateSharedDrives.value
            ) ||
            (requiresChangeLog && !changeLogConfirmed)
          }
          onClick={() => setOpenCreateSharedDriveDialog(true)}
          label="Add Shared Drive"
          tooltipLabel={
            !isAbleToSeeUIElement(
              driveRoles,
              DriveRoles.CanCreateSharedDrives.value
            )
              ? Messages.Errors.Permission.Acting(
                  DriveRoles.CanCreateSharedDrives.value
                )
              : ''
          }
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              void queryClient.invalidateQueries({
                queryKey: [UserKeys.DriveDocuments],
              });
              void queryClient.invalidateQueries({
                queryKey: [UserKeys.DriveFolders],
              });
              void queryClient.invalidateQueries({
                queryKey: [UserKeys.DrivePermissions],
              });
              void queryClient.invalidateQueries({
                queryKey: [UserKeys.DriveAcls],
              });

              void queryClient.invalidateQueries({
                queryKey: [UserKeys.SharedDrivesIndexedPage],
              });

              void queryClient.invalidateQueries({
                queryKey: [UserKeys.SharedDrivesForUser],
              });

              void queryClient.invalidateQueries({
                queryKey: [UserKeys.SharedDriveFolders],
              });

              void queryClient.invalidateQueries({
                queryKey: [UserKeys.SharedDriveDocuments],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="sharedDrivesIndexedGridStates"
            module={ModuleList.modules.devices.name}
            section={ModuleList.modules.devices.sections.mobileManagement}
          />
        </>
      }
    />
  );
}
